import React, { useEffect, useState } from 'react'
import { signIn } from 'aws-amplify/auth'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext';

const Authenticate = () => {
    const { user, isLoading, signOut } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        document.body.style.backgroundColor = '#1f2937';
        return () => {
            document.body.style.backgroundColor = '';
        };
    }, []);

    const handleEmailAuth = async (e) => {
        e.preventDefault();
        setError('');

        try {
            await signIn({ username: email, password });
            navigate('/admin');
        } catch (err) {
            const errorType = err.__type || err.name || '';
            const errorMessage = err.message || '';

            if (
                errorType === 'NotAuthorizedException' ||
                errorType.includes('NotAuthorized') ||
                errorMessage.includes('Incorrect username or password')
            ) {
                setError('Incorrect email or password. Please try again.');
            } else {
                setError(errorMessage || 'Authentication failed. Please try again.');
            }
        }
    };

    if (isLoading) {
        return (
            <div className="flex justify-center items-center min-h-96">
                <div className="text-white text-xl">Loading...</div>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-96 text-white">
            {user ? (
                <div className="text-center space-y-4">
                    <h2 className="text-2xl font-bold">Welcome back.</h2>
                    <p>Signed in as: {user.username}</p>
                    <button
                        onClick={signOut}
                        className="bg-red-600 hover:bg-red-700 px-6 py-2 rounded-lg font-semibold transition-colors"
                    >
                        Sign Out
                    </button>
                </div>
            ) : (
                <div className="max-w-md mx-auto bg-gray-800 bg-opacity-90 p-8 rounded-lg">
                    <h2 className="text-2xl font-bold text-center mb-1">Admin Login</h2>
                    <p className="text-center text-gray-400 text-sm mb-6">Site administration access</p>

                    {error && (
                        <div className="mb-4 p-3 bg-red-600 bg-opacity-20 border border-red-500 rounded text-red-200 text-sm">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleEmailAuth} className="space-y-4">
                        <div>
                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-blue-500"
                            />
                        </div>
                        <div>
                            <input
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-blue-500"
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-lg font-semibold transition-colors"
                        >
                            Sign In
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
}

export default Authenticate
